var BsubWidget = (function () {
  function e() {
    (this.attrs = {
      purchaseOptionOneTime: "data-bsub-purchase-option-one-time",
      sellingPlanGroupId: "data-bsub-selling-plan-group-id",
      sellingPlanIdInput: "data-bsub-selling-plan-id-input",
      widget: "data-bsub-widget",
      sellingPlanOptionsContainer: "data-bsub-selling-plan-options-container",
      sellingPlanOption: "data-bsub-selling-plan-option",
      sellingPlansContainer: "data-bsub-selling-plans-container",
      sellingPlanGroup: "data-bsub-selling-plan-group",
      sellingPlanGroupInput: "data-bsub-selling-plan-group-input",
      sellingPlan: "data-bsub-selling-plan",
      sellingPlanInput: "data-bsub-selling-plan-input",
      productJson: "data-bsub-product-json",
      groupDiscountSummary: "data-bsub-group-discount-summary",
      perDeliveryPrice: "data-bsub-per-delivery-price",
      cartPopupDetails: "data-bsub-cart-popup-details",
      cartPageDetails: "data-bsub-cart-page-details",
      moneyFormat: "data-bsub-money-format",
      pageTemplate: "data-bsub-page-template",
    }),
      (this.selectors = {
        productForm: 'form[action="/cart/add"]',
        variantIdInput: '[name="id"]',
        variantSelector: [
          "#shappify-variant-id",
          ".single-option-selector",
          "select[name=id]",
          "input[name=id]",
        ],
      }),
      Object.entries(this.attrs).forEach(
        function ([e, t]) {
          this.selectors[e] = `[${t}]`;
        }.bind(this)
      ),
      (this.classes = { hidden: "bsub__hidden" }),
      (this.products = {}),
      (this.variants = {}),
      (this.sellingPlanGroups = {}),
      (this.pageTemplate = "");
  }
  return (
    (e.prototype = Object.assign({}, e.prototype, {
      init: function () {
        (console.debug("BSUB: Initializing widgets..."),
        document.querySelector(this.selectors.widget))
          ? (this._parsePageTemplate(),
            this._parseProductJson(),
            this._addVariantChangeListener(),
            document.querySelectorAll(this.selectors.widget).forEach(
              function (e) {
                this._renderPrices(e), this._renderGroupDiscountSummary(e);
              }.bind(this)
            ),
            window.addEventListener(
              "pageshow",
              function () {
                this.syncAllVisuallySelected();
              }.bind(this)
            ),
            console.debug("BSUB: Successfully initialized widgets."))
          : console.debug(
              "BSUB: No widgets detected, skipping initialization."
            );
      },
      syncAllVisuallySelected: function () {
        document
          .querySelectorAll(this.selectors.widget)
          .forEach(this._syncVisuallySelected.bind(this));
      },
      _syncVisuallySelected: function (e) {
        e.querySelector(
          `${this.selectors.sellingPlanGroupInput}:checked`
        ).dispatchEvent(new Event("change"));
      },
      _addVariantChangeListener: function () {
        document
          .querySelectorAll(this.selectors.variantSelector.join())
          .forEach(
            function (e) {
              e &&
                e.addEventListener(
                  "change",
                  function (e) {
                    var t = e.target
                      .closest(this.selectors.productForm)
                      .querySelector(this.selectors.widget);
                    setTimeout(
                      function () {
                        this._renderPrices(t),
                          this._renderGroupDiscountSummary(t);
                      }.bind(this),
                      100
                    );
                  }.bind(this)
                );
            }.bind(this)
          );
      },
      _parsePageTemplate: function () {
        var e = document.querySelector(this.selectors.pageTemplate);
        null !== e && (this.pageTemplate = e.value);
      },
      _parseProductJson: function () {
        document.querySelectorAll(this.selectors.productJson).forEach(
          function (e) {
            var t = JSON.parse(e.innerHTML);
            (this.products[e.dataset.bsubProductId] = t),
              t.selling_plan_groups.forEach(
                function (e) {
                  this.sellingPlanGroups[e.id] = e;
                }.bind(this)
              ),
              t.variants.forEach(
                function (e) {
                  this.variants[e.id] = e;
                }.bind(this)
              );
          }.bind(this)
        );
      },
      renderAllPrices: function () {
        document
          .querySelectorAll(this.selectors.widget)
          .forEach(this._renderPrices.bind(this));
      },
      _renderPrices: function (e) {
        void 0 === e && (e = document.querySelector(this.selectors.widget));
        var t = e.querySelectorAll(this.selectors.sellingPlan),
          n = this._getVariantId(e);
        n &&
          t.forEach(
            function (e) {
              var t = e.dataset.bsubSellingPlanId,
                i = this._getSellingPlanAllocation(n, t),
                s = e.querySelector(this.selectors.perDeliveryPrice),
                a = i.per_delivery_price,
                l = this._formatPrice(a),
                v = $(".bold-ro__initial-discount-percent").text(
                  $(".bsub-widget__group-discount-summary")
                    .text()
                    .replace("(Save ", "")
                    .replace(")", "")
                ),
                w = $(".bold-ro__initial-discount-price").text(
                  $(
                    ".bsub-widget__plan-pricing span[data-bsub-per-delivery-price]"
                  )
                    .eq(0)
                    .text()
                );
              s.innerHTML = l;
            }.bind(this)
          );
      },
      renderAllGroupDiscountSummary: function () {
        document
          .querySelectorAll(this.selectors.widget)
          .forEach(this._renderGroupDiscountSummary.bind(this));
      },
      _renderGroupDiscountSummary: function (e) {
        var t = e.querySelector(this.selectors.productJson).dataset
          .bsubProductId;
        e.querySelectorAll(this.selectors.sellingPlanGroup).forEach(
          function (e) {
            var n = e.dataset.bsubSellingPlanGroupId,
              i = this.products[t].selling_plan_groups
                .find(function (e) {
                  return e.id === n;
                })
                .selling_plans.map(function (e) {
                  return 0 === e.price_adjustments.length
                    ? { value: 0, type: "" }
                    : {
                        value: e.price_adjustments[0].value,
                        type: e.price_adjustments[0].value_type,
                      };
                }),
              s = i.reduce(function (e, t) {
                return e.value > t.value ? e : t;
              });
            if (0 !== s.value) {
              var a = i.some(function (e) {
                  return e.value !== s.value;
                }),
                l = e.querySelector(this.selectors.groupDiscountSummary),
                r = "(Save";
              switch ((a && (r += " up to "), s.type)) {
                case "fixed_amount":
                  r += this._formatPrice(s.value);
                  break;
                case "percentage":
                default:
                  r += ` ${s.value}%`;
              }
              (r += ")"), (l.innerHTML = r);
            }
          }.bind(this)
        );
      },
      handleSellingPlanGroupChange: function (e) {
        var t = e.target,
          n = t.value,
          i = t.closest(this.selectors.widget);
        if (
          (i.querySelectorAll(this.selectors.sellingPlansContainer).forEach(
            function (e) {
              e.dataset.bsubSellingPlanGroupId === n && t.checked
                ? e.classList.remove(this.classes.hidden)
                : e.classList.add(this.classes.hidden);
            }.bind(this)
          ),
          "once" !== n)
        ) {
          var s = this._getActiveSellingPlanId(i, n);
          this._setSellingPlanIdInput(i, s);
        } else this._setSellingPlanIdInput(i, "");
      },
      handleSellingPlanChange: function (e) {
        var t = e.target,
          n = t.closest(this.selectors.widget);
        this._setSellingPlanIdInput(n, t.value);
      },
      handleSellingPlanOptionChange: function (e) {
        var t = e.target.closest(this.selectors.widget),
          n = e.target.dataset.bsubSellingPlanGroupId,
          i = this._getSellingPlanOptions(t, n),
          s = this._getSellingPlanFromOptions(n, i);
        this._setSellingPlanIdInput(s.id);
      },
      _setSellingPlanIdInput: function (e, t) {
        var n = e.querySelector(this.selectors.sellingPlanIdInput),
          i = this._getVariantId(e);
        (n.value = t),
          /.*(product).*/.test(this.pageTemplate) &&
            this._updateHistoryState(i, t);
      },
      _getSellingPlanGroup: function (e) {
        if (this.sellingPlanGroups[e]) return this.sellingPlanGroups[e];
        console.error("BSUB: Selling plan group data not found.");
      },
      _getSellingPlanOptions: function (e, t) {
        var n = [];
        return (
          e
            .querySelectorAll(
              `${this.selectors.sellingPlanOption}[${this.attrs.sellingPlanGroupId}="${t}"]:checked`
            )
            .forEach(function (e) {
              n.push({ index: e.dataset.bsubOptionIndex, value: e.value });
            }),
          n
        );
      },
      _getSellingPlanFromOptions: function (e, t) {
        return this._getSellingPlanGroup(e).selling_plans.find(function (e) {
          return t.every(function (t) {
            return e.options[t.index].value === t.value;
          });
        });
      },
      _getVariantId: function (e) {
        var t = e.closest(this.selectors.productForm);
        return t
          ? t.querySelector(this.selectors.variantIdInput).value
          : (console.error("BSUB: Could not find product form."), null);
      },
      _getActiveSellingPlanId: function (e, t) {
        var n = e.querySelector(`input[name=bsub-selling-plan-${t}]:checked`);
        return (
          n ||
            console.error(
              `BSUB: Could not find active plan ID for group ${t}.`
            ),
          n.value
        );
      },
      /** _updateHistoryState: function (e, t) {
        if (history.replaceState && e) {
          var n =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname +
            "?";
          t && (n += "selling_plan=" + t + "&"),
            (n += "variant=" + e),
            window.history.replaceState({ path: n }, "", n);
        }
      }, **/
      _updateHistoryState: function (e, t) {
          if (history.replaceState && e) {
            // Get existing query parameters
            var params = new URLSearchParams(window.location.search);
            
            // Update/add the variant and selling_plan
            if (t) {
              params.set('selling_plan', t);
            }
            params.set('variant', e);
            
            // Build the new URL with all parameters preserved
            var n =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?" +
              params.toString();
              
            window.history.replaceState({ path: n }, "", n);
          }
        },
      _getSellingPlanAllocation(e, t) {
        var n = this.variants[e];
        return n
          ? n.selling_plan_allocations.find(function (e) {
              return `${e.selling_plan_id}` === t;
            })
          : (console.error(`BSUB: Could not find variant ID ${e}`), null);
      },
      _formatPrice(e, t) {
        var n = document.querySelector(this.selectors.moneyFormat),
          i = n ? n.getAttribute("data-bsub-money-format") : null;
        "string" == typeof e && (e = e.replace(".", ""));
        var s = "",
          a = /\{\{\s*(\w+)\s*\}\}/,
          l =
            t ||
            i ||
            theme.moneyFormat ||
            theme.strings.moneyFormat ||
            Shopify.money_format ||
            "$ {% raw %}{{ amount }}{% endraw %}";
        function r(e, t, n, i) {
          if (((n = n || ","), (i = i || "."), isNaN(e) || null === e))
            return 0;
          var s = (e = (e / 100).toFixed(t)).split(".");
          return (
            s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
            (s[1] ? i + s[1] : "")
          );
        }
        switch (l.match(a)[1]) {
          case "amount":
            s = r(e, 2);
            break;
          case "amount_no_decimals":
            s = r(e, 0);
            break;
          case "amount_with_comma_separator":
            s = r(e, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            s = r(e, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            s = r(e, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            s = r(e, 2, "'");
        }
        return l.replace(a, s);
      },
    })),
    e
  );
})();
document.addEventListener("DOMContentLoaded", function () {
  (window.BOLD = window.BOLD || {}),
    (window.BOLD.BsubWidget = new BsubWidget()),
    window.BOLD.BsubWidget.init();
});
